import * as React from "react";
import PropTypes from "prop-types";

// Material
import { Button as MuiButton, makeStyles } from "@material-ui/core";

// Styles
const useStyles = makeStyles((theme) => ({
	success: {
		color: (props) =>
			props.variant === "contained"
				? theme.palette.common.white
				: theme.palette.success.main,
		borderColor: theme.palette.success.main,
		backgroundColor: (props) =>
			props.variant === "contained"
				? theme.palette.success.main
				: theme.palette.background.white,
		"&:hover": {
			backgroundColor: (props) =>
				props.variant === "contained"
					? theme.palette.success.dark
					: theme.palette.background.white,
		},
	},
}));

const Button = ({
	label,
	onClick,
	color,
	size,
	variant,
	disabled,
	startIcon,
	endIcon,
	fullWidth,
	...props
}) => {
	const classes = useStyles({ variant });
	return (
		<MuiButton
			disabled={disabled}
			color={color === "success" ? "default" : color}
			variant={variant}
			size={size}
			startIcon={startIcon}
			endIcon={endIcon}
			onClick={onClick}
			fullWidth={fullWidth}
			className={color === "success" ? classes.success : ""}
			{...props}
		>
			{label}
		</MuiButton>
	);
};

export default Button;

Button.propTypes = {
	size: PropTypes.oneOf(["small", "medium", "large"]),
	color: PropTypes.oneOf([
		"primary",
		"secondary",
		"default",
		"inherit",
		"success",
	]),
	variant: PropTypes.oneOf(["contained", "outlined", "text"]),
	label: PropTypes.any.isRequired,
	disabled: PropTypes.bool,
	endIcon: PropTypes.node,
	startIcon: PropTypes.node,
	onClick: PropTypes.func.isRequired,
	fullWidth: PropTypes.bool,
};

Button.defaultProps = {
	variant: "contained",
	color: "primary",
	size: "medium",
	disabled: false,
	endIcon: null,
	startIcon: null,
	fullWidth: false,
};
